module.exports = __webpack_public_path__ + "img/logred.31c09d93.svg";